import { render, staticRenderFns } from "./TagWithDropdown.vue?vue&type=template&id=732d586c&scoped=true&"
import script from "./TagWithDropdown.vue?vue&type=script&lang=ts&"
export * from "./TagWithDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./TagWithDropdown.vue?vue&type=style&index=0&id=732d586c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732d586c",
  null
  
)

export default component.exports